import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Transpordi tasu

  <span style="color:#85c1dc;">**FI:**</span>
  Toimituskulut

  <span style="color:#85c1dc;">**RU:**</span>
  Плата за транспорт
*/
/* @__NO_SIDE_EFFECTS__ */
const m953 = msg(
  mf`Transpordi tasu`,
  mf`Toimituskulut`,
  mf`Плата за транспорт`,
)

export { m953 as 'w.basket.summary.transport' }